import { changeLanguage, getLanguage, getLocaleOptions } from '@/i18n';
import { useFunction } from '@ts-max/hooks';
import { Select, type SelectProps } from 'antd';
import { type CSSProperties, useState } from 'react';

interface LocaleSelectProps extends SelectProps {
  style?: CSSProperties;
}

export function LocaleSelect(props: LocaleSelectProps) {
  const { style, ...others } = props;
  const localeOptions = getLocaleOptions();
  const [language, setLanguage] = useState(getLanguage());

  const handleChange = useFunction(async (val) => {
    // 切换语言，内部存储
    await changeLanguage(val);

    setLanguage(val);

    // 刷新页面，有的翻译是写在js中的，无法做的实时更新，尽量不要使用，影响用户体验
    // window.location.reload();
  });

  return (
    <Select
      value={language}
      onChange={handleChange}
      options={localeOptions as any[]}
      style={{
        border: 'none',
        width: 120,
        ...style,
      }}
      {...others}
    />
  );
}
